import { FormField, FormItem, FormLabel } from "@/components/ui/form";

import { useFormContext } from "react-hook-form";
import PasswordInput from "./PasswordInput";

type PasswordFieldInputProps = {
	name: string;
	label: string;
	placeholder?: string;
	value?: string;
	disabled?: boolean;
};

function PasswordField({ name, label, value }: PasswordFieldInputProps) {
	return (
		<>
					<PasswordInput
						name={`${name}.password`}
				label={label}
						placeholder="Create a password"
						autoComplete="new-password"
					/>
					<PasswordInput
						name={`${name}.confirmPassword`}
						label={""}
						placeholder="Confirm password"
						autoComplete="new-password"
					/>
		</>
	);
}

export default PasswordField;
